import React from 'react';
import { Discount } from '../../../../types/discounts';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

interface PeriodProps extends WithTranslation {
    discount: Discount;
}

const Item = (
    {
        discount,
        t,
    }: PeriodProps
) => {
    const quantity = discount.requirement.item?.quantity;
    const items = discount.requirement.item?.items;
    const mixes = discount.requirement.item?.mixes;

    return (
        <ItemContainer>
            {quantity && (
                <ItemSection>
                    <Header>{t('customers.customer.discounts.quantity')}</Header>
                    <Value>{quantity}</Value>
                </ItemSection>
            )}
            {mixes && (
                <ItemSection>
                    <BlockHeader>{t('customers.customer.discounts.mixes')}</BlockHeader>
                    <ul>
                        {mixes.map((mix, i) => {
                            return (
                                <MixListItem key={i}>
                                    <strong>{t('customers.customer.discounts.quantity')}</strong>: {mix.quantity}, <strong>{t('customers.customer.discounts.reward_eligible')}</strong>: {t(`customers.customer.discounts.${mix.reward_eligible}`)}
                                    <Header>{t('customers.customer.discounts.items')}</Header>
                                    {mix.items && (
                                        <ul>
                                            {mix.items.map((item, j) => {
                                                const { id, group_id } = item;
                                                return (
                                                    <li key={j}>
                                                        {id && id}
                                                        {group_id && group_id}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    )}
                                </MixListItem>
                            );
                        })}
                    </ul>
                </ItemSection>
            )}
            {items && (
                <ItemSection>
                    <BlockHeader>{t('customers.customer.discounts.items')}</BlockHeader>
                    <ul>
                        {items.map(item => <li key={item.id}>{item.id}</li>)}
                    </ul>
                </ItemSection>
            )}
        </ItemContainer>
    );
};

export default withTranslation()(Item);

const ItemContainer = styled.div`
    font-size: 14px;
`;

const Header = styled.span`
    font-weight: 700;
    color: #46535E;
`;

const BlockHeader = styled(Header)`
    display: block;
`;

const Value = styled.span`
    margin-left: 8px;
`;

const MixListItem = styled.li`
    & + & {
        margin-top: 20px;
    }
`;

const ItemSection = styled.div`
    & + & {
        margin-top: 16px;
    }
`;



